export default __webpack_public_path__ + "static/media/urduflix-placeholder.13fcf3c9.png";